import { PermissionService, RoutesService, eLayoutType } from '@abp/ng.core';
import { inject, provideAppInitializer } from '@angular/core';
import { combineLatest } from 'rxjs';
import { SCMPermissions } from './shared/AppConsts';

export const APP_ROUTE_PROVIDER = [
  provideAppInitializer(() => {
    configureRoutes();
  }),
];

function configureRoutes() {
  const routes = inject(RoutesService);
  const permissionService = inject(PermissionService);
  const orderPolicies = [
    SCMPermissions.Orders.Supervisor,
    SCMPermissions.Orders.Contractor,
    SCMPermissions.Orders.Silviculture,
    SCMPermissions.Orders.WarehouseManager,
  ];

  routes.add([
      {
        path: '/',
        name: '::Menu:Home',
        iconClass: 'fas fa-home',
        order: 1,
        layout: eLayoutType.application,
        invisible: false,
      },
      {
        path: '/orders/supervisor',
        name: '::Menu:Orders.Supervisor',
        iconClass: 'fas fa-clipboard-check',
        order: 2,
        layout: eLayoutType.application,
        requiredPolicy: SCMPermissions.Orders.Supervisor,
      },
      {
        path: '/orders/contractor',
        name: '::Menu:Orders.Contractor',
        iconClass: 'fas fa-clipboard-list',
        order: 3,
        layout: eLayoutType.application,
        requiredPolicy: SCMPermissions.Orders.Contractor,
      },
      {
        path: '/orders/silviculture',
        name: '::Menu:Orders.Silviculture',
        iconClass: 'fas fa-tree',
        order: 4,
        layout: eLayoutType.application,
        requiredPolicy: SCMPermissions.Orders.Silviculture,
      },
      {
        path: '/orders/warehouse-manager',
        name: '::Menu:Orders.WarehouseManager',
        iconClass: 'fas fa-warehouse',
        order: 5,
        layout: eLayoutType.application,
        requiredPolicy: SCMPermissions.Orders.WarehouseManager,
      },
      {
        path: '/synchronization',
        name: '::Menu:Synchronization',
        iconClass: 'fas fa-sync-alt',
        order: 6,
        layout: eLayoutType.application,
        requiredPolicy: SCMPermissions.Sync,
      },
  ]);

  combineLatest(orderPolicies.map(policy => permissionService.getGrantedPolicy$(policy))).subscribe(
    grantedPolicies => routes.patch('::Menu:Home', { invisible: grantedPolicies.some(Boolean) }),
  );
}
